/* Fardo.cl - Capa B2B de las cajas de precio por volumen.
   Estilos: snippets/fardo-tier-headline.liquid
   Markup base y logica de precios: tier-price-cards.liquid + fardo-tier-cards.js

   Agrega cuatro cosas al grid existente:
     1. El encabezado "Precios por volumen".
     2. Un icono con tantas unidades como tiene el tramo (1, 3, 5, 10),
        dibujadas como FARDO, SACO o CAJA segun la unidad del producto.
     3. La linea de kilos aproximados por tramo (si el titulo declara kg).
     4. La marca "Mas conveniente" en el mejor tramo disponible.
*/
(function () {
  var KG = null;

  /* [trazo, relleno] por tono de caja */
  var TONE_COLOR = {
    a: ['%2334497A', '%23FFFFFF'],
    b: ['%2334497A', '%23FFFFFF'],
    c: ['%2324386A', '%23FFFFFF'],
    d: ['%23FFFFFF', '%23241A4F']
  };

  (function readKg() {
    var title = String(window.FARDO_PRODUCT_TITLE || '');
    var m = title.match(/(\d+(?:[.,]\d+)?)\s*(?:kgs?|kilos?|kilogramos?)\b/i);
    if (m) {
      var n = parseFloat(m[1].replace(',', '.'));
      if (!isNaN(n) && n > 0) KG = n;
    }
  })();

  function round1(v) {
    return Math.round(v * 10) / 10;
  }

  function kgNumber(value) {
    var v = round1(value);
    return (v % 1 === 0) ? String(v) : String(v).replace('.', ',');
  }

  /* ---- Icono del tramo: fardo, saco o caja segun la unidad del producto ----
     La unidad se lee de la etiqueta de la caja ("3 Fardos", "5 Sacos"...),
     que tier-price-cards.liquid ya resuelve (metafield custom.unidad /
     "Presentacion en ___" de la descripcion / titulo).
     Saco y Bolsa -> saco. Caja y Pack -> caja. Lo demas -> fardo.
     Se apilan en piramide: 1 / 2+1 / 3+2 / 4+3+2+1 (=10). */
  var ICON_W = 64, ICON_H = 38;

  function unitKind(card) {
    var label = card.querySelector('.fardo-tier-card__qty');
    var t = (label ? label.textContent : '').toLowerCase();
    if (/saco|bolsa/.test(t)) return 'saco';
    if (/caja|pack/.test(t)) return 'caja';
    return 'fardo';
  }

  /* Cada unidad se dibuja en una celda de 20x16. */
  var UNIT = {
    /* Fardo: bulto prensado con zunchos */
    fardo: function (fill) {
      return "<rect x='1.2' y='1.6' width='17.6' height='13.2' rx='4.2' fill='" + fill + "'/>" +
        "<path d='M1.6 6.1h16.8M1.6 10.3h16.8M10 1.8v12.8'/>";
    },
    /* Saco: rectangular, con costura arriba y puntas */
    saco: function (fill) {
      return "<path d='M2.4 1.4 4 2.6h12l1.6-1.2-.4 2.8v9.6c0 .8-.6 1.4-1.4 1.4H4.2c-.8 0-1.4-.6-1.4-1.4V4.2z' fill='" + fill + "'/>" +
        "<path d='M2.8 4.6h14.4M2.8 12.6h14.4'/>";
    },
    /* Caja: carton con solapas y cinta */
    caja: function (fill) {
      return "<path d='M2 5.2 4.4 1.6h11.2L18 5.2v8.4c0 .7-.5 1.2-1.2 1.2H3.2c-.7 0-1.2-.5-1.2-1.2z' fill='" + fill + "'/>" +
        "<path d='M2 5.2h16M8.4 1.6l-.5 3.6v3.2l2.1-1 2.1 1V5.2l-.5-3.6'/>";
    }
  };

  function unitsIcon(count, kind, color, fill) {
    var rows;
    if (count <= 1) rows = [1];
    else if (count <= 3) rows = [2, 1];
    else if (count <= 6) rows = [3, 2];
    else rows = [4, 3, 2, 1];

    var cw = 20, ch = 16, ox = 0.92, oy = 0.82; /* solape entre unidades */
    var wUnits = cw * (1 + (rows[0] - 1) * ox);
    var hUnits = ch * (1 + (rows.length - 1) * oy);
    var s = Math.min(ICON_W / wUnits, ICON_H / hUnits, 2);
    var stroke = round1(Math.max(1.05, 1.5 / s) * 10) / 10;
    var draw = UNIT[kind] || UNIT.fardo;
    var parts = [];

    /* de arriba hacia abajo, asi la fila de abajo queda delante */
    for (var r = rows.length - 1; r >= 0; r--) {
      var n = rows[r];
      var rowW = cw * s * (1 + (n - 1) * ox);
      var x0 = (ICON_W - rowW) / 2;
      var yTop = (ICON_H - hUnits * s) / 2 + (rows.length - 1 - r) * ch * s * oy;
      for (var i = 0; i < n; i++) {
        var x = x0 + i * cw * s * ox;
        parts.push("<g transform='translate(" + round1(x) + " " + round1(yTop) + ") scale(" +
          (Math.round(s * 1000) / 1000) + ")'>" + draw(fill) + "</g>");
      }
    }

    return "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 " + ICON_W + " " + ICON_H +
      "' fill='none' stroke='" + color + "' stroke-width='" + stroke +
      "' stroke-linejoin='round' stroke-linecap='round'>" + parts.join('') + "</svg>";
  }
  window.__fardoUnitsIcon = unitsIcon;

  function addIcons(container) {
    container.querySelectorAll('[data-tier]').forEach(function (card) {
      var qty = parseInt(card.getAttribute('data-qty'), 10);
      if (!qty) return;
      var tone = TONE_COLOR[card.getAttribute('data-tone')] || TONE_COLOR.a;
      var value = 'url("data:image/svg+xml;utf8,' + unitsIcon(qty, unitKind(card), tone[0], tone[1]) + '")';
      if (card.style.getPropertyValue('--tier-icon') !== value) {
        card.style.setProperty('--tier-icon', value);
        card.style.setProperty('--tier-icon-w', ICON_W + 'px');
        card.style.setProperty('--tier-icon-h', ICON_H + 'px');
        card.setAttribute('data-unit-kind', unitKind(card));
      }
    });
  }

  function addHeader(container) {
    if (container.querySelector('[data-fardo-tier-head]')) return;
    var el = document.createElement('div');
    el.className = 'fardo-tier-head';
    el.setAttribute('data-fardo-tier-head', '');
    el.innerHTML =
      '<span class="fardo-tier-head__main">' +
        '<span class="fardo-tier-head__icon" aria-hidden="true"></span>' +
        '<span class="fardo-tier-head__text">' +
          '<span class="fardo-tier-head__title">Precios por volumen</span>' +
          '<span class="fardo-tier-head__sub">A mayor cantidad, mayor descuento</span>' +
        '</span>' +
      '</span>' +
      '<span class="fardo-tier-head__pill">Ahorra más y haz crecer tu negocio</span>';
    container.insertBefore(el, container.firstChild);
  }

  function addKgLines(container) {
    if (KG == null) return;
    container.querySelectorAll('[data-tier]').forEach(function (card) {
      var qty = parseInt(card.getAttribute('data-qty'), 10);
      if (!qty) return;

      var el = card.querySelector('[data-fardo-kg]');
      if (!el) {
        el = document.createElement('span');
        el.className = 'fardo-tier-card__kg';
        el.setAttribute('data-fardo-kg', '');
        card.appendChild(el);
      }

      var label = card.querySelector('.fardo-tier-card__qty');
      var openEnded = !!(label && label.textContent.indexOf('+') > -1);
      var text = kgNumber(KG * qty) + (openEnded ? '+' : '') + ' kg aprox.';
      if (el.textContent !== text) el.textContent = text;
    });
  }

  /* El tramo con mayor cantidad que siga visible y con descuento. */
  function markBest(container) {
    var cards = Array.prototype.slice.call(container.querySelectorAll('[data-tier]'));
    var best = null;
    cards.forEach(function (card) {
      if (card.hidden) return;
      var discount = parseInt(card.getAttribute('data-discount'), 10) || 0;
      var qty = parseInt(card.getAttribute('data-qty'), 10) || 0;
      if (discount > 0 && (best === null || qty > best.qty)) best = { el: card, qty: qty };
    });
    cards.forEach(function (card) {
      var on = !!(best && card === best.el);
      if (card.classList.contains('is-best') !== on) card.classList.toggle('is-best', on);
    });
  }

  function apply() {
    document.querySelectorAll('[data-tier-cards]').forEach(function (container) {
      addHeader(container);
      addIcons(container);
      addKgLines(container);
      markBest(container);
    });
  }

  function boot() {
    apply();
    document.querySelectorAll('[data-tier-cards]').forEach(function (container) {
      if (container.__fardoB2bWatched) return;
      container.__fardoB2bWatched = true;
      new MutationObserver(function () {
        clearTimeout(window.__fardoTierB2bTimer);
        window.__fardoTierB2bTimer = setTimeout(apply, 70);
      }).observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(boot, 900);
  setTimeout(boot, 2200);
})();
